import { Palette } from "lucide-react";

export function AuraCoreColorsPalette() {
  const colors = [
    {
      name: "Primary action",
      color: "Green — #22c55e",
      bgStyle: "bg-gradient-to-br from-emerald-500 to-emerald-600"
    },
    {
      name: "Background",
      color: "White — #ffffff",
      bgStyle: "",
      customStyle: { backgroundColor: "#ffffff" }
    },
    {
      name: "Text / Headings",
      color: "Slate 900 — #0f172a",
      bgStyle: "",
      customStyle: { backgroundColor: "#0f172a" }
    },
    {
      name: "Muted text",
      color: "Slate 600 — #475569",
      bgStyle: "",
      customStyle: { backgroundColor: "#475569" }
    },
    {
      name: "Borders / dividers",
      color: "Slate 200 — #e2e8f0",
      bgStyle: "",
      customStyle: { backgroundColor: "#e2e8f0" }
    },
    {
      name: "Alerts",
      color: "Amber — #f59e0b, Red — #ef4444",
      bgStyle: "",
      isAlerts: true
    }
  ];

  return (
    <div className="mt-8 rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="px-4 py-3 border-b border-slate-200 flex items-center gap-2">
        <div className="h-4 w-4 p-1 rounded-md bg-emerald-50 text-emerald-600 border border-emerald-100 flex items-center justify-center">
          <Palette className="h-2.5 w-2.5" />
        </div>
        <h2 className="text-[15px] font-medium tracking-tight text-slate-900">Core colors</h2>
      </div>
      
      <div className="p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
          {colors.map((colorItem, index) => (
            <div key={index} className="group rounded-xl border border-slate-200 hover:border-slate-300 bg-white p-3 transition-colors">
              <div className="flex items-center gap-3">
                {colorItem.isAlerts ? (
                  <div className="flex -space-x-1">
                    <div className="h-8 w-8 rounded-md shadow-inner ring-1 ring-black/5 bg-gradient-to-br from-amber-500 to-orange-500"></div>
                    <div className="h-8 w-8 rounded-md shadow-inner ring-1 ring-black/5 bg-gradient-to-br from-red-500 to-rose-500"></div>
                  </div>
                ) : (
                  <div 
                    className={`h-8 w-8 rounded-md shadow-inner ring-1 ring-black/5 ${colorItem.bgStyle}`}
                    style={colorItem.customStyle}
                  ></div>
                )}
                <div>
                  <div className="text-[13px] text-slate-500">{colorItem.name}</div>
                  <div className="text-[15px] text-slate-800 font-medium">{colorItem.color}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-3 text-[13px] text-slate-500">
          These match the current UI tokens and keep contrast and clarity in light mode.
        </p>
      </div>
    </div>
  );
}